import { useEffect, useRef } from 'react';

/**
 * Auto-save: when saveTrigger increments, debounce and call saveFn.
 * Use for edit forms: increment saveTrigger when user changes a field.
 * Does not run on initial mount (saveTrigger starts at 0).
 *
 * @param {number} saveTrigger - Increment when form data changes
 * @param {function} saveFn - async () => void, performs the save
 * @param {object} options - { enabled: boolean, delayMs: number }
 */
export function useAutoSave(saveTrigger, saveFn, { enabled = true, delayMs = 500 } = {}) {
  const saveFnRef = useRef(saveFn);
  saveFnRef.current = saveFn;

  useEffect(() => {
    if (!enabled || saveTrigger === 0) return;

    const t = setTimeout(() => {
      saveFnRef.current().catch((err) => {
        console.error('Auto-save failed:', err);
        const apiMsg =
          err?.response?.data?.error ||
          err?.response?.data?.message ||
          (typeof err?.response?.data === 'string' ? err.response.data : null);
        const detail = apiMsg || err?.message || '';
        const hint = detail
          ? `Auto-save failed: ${detail}`
          : 'Auto-save failed. Please check your connection and try again.';
        alert(hint);
      });
    }, delayMs);
    return () => clearTimeout(t);
  }, [saveTrigger, enabled, delayMs]);
}
